import { takeLatest, put, call, fork, all, select, delay } from "redux-saga/effects"
import * as actions from "@/AppRedux/actions/admin/hotelProfileConfig/hotelProfileConfigType"
import * as actionCreation from "@/AppRedux/actions/admin/hotelProfileConfig"

import { APIPostRequest } from "@/services/connection"
import { SagaIterator } from "redux-saga"
import { API_HEADERS, API_PMS_URL } from "@/constants/ApiSetting"

import { RootState } from "@/AppRedux/reducers"

function* hotelProfileContentRequestProcess(): SagaIterator {
  try {
    const authState = yield select((state: RootState) => state.auth)
    const { propCode } = authState

    const url = `${API_PMS_URL}/admin/hotel_profile/get`
    const API_BODY = {
      prop_code: propCode,
    }

    const response = yield call(APIPostRequest, url, API_BODY, API_HEADERS)

    if (response.status === 200 && response.data?.result_code === "0") {
      yield put(actionCreation.setHotelProfileContentSuccess(response.data.result_data))
    } else {
      const message = response.data?.result_msg || "Failed to get hotel profile content"
      yield put(actionCreation.setHotelProfileContentFailure(message))
    }
  } catch (error: any) {
    const message = error?.message || "An unexpected error occurred"
    yield put(actionCreation.setHotelProfileContentFailure(message))
  }
}


function* hotelProfileContentUpdateBatchProcess({
  payload,
}: actions.HotelProfileContentUpdateBatchRequest): SagaIterator {
  try {
    const authState = yield select((state: RootState) => state.auth)
    const hotelProfileState = yield select((state: RootState) => state.hotelProfileConfig)
    const { propCode } = authState

    const url = `${API_PMS_URL}/admin/hotel_profile/update`
    /* Prepare data for update */
    const API_BODY: actions.HotelProfileResponse = {
      prop_code: propCode,
      ...hotelProfileState.dataSource,
      cover_image: payload.cover_image,
      contents: payload.contents,
      fax: payload.fax,
      phones: payload.phones,
      emails: payload.emails,
      website: payload.website,
      social_media: payload.social_media,
    }

    console.log("Batch updating hotel profile content:", API_BODY)
    //yield delay(5000) // Simulate API call delay
    // yield put(actionCreation.setHotelProfileContentUpdateSuccess())
    // return

    const response = yield call(APIPostRequest, url, API_BODY, API_HEADERS)
    console.log("Batch update response:", response)
    if (response.status === 200 && response.data?.result_code === "0") {
      yield put(actionCreation.setHotelProfileContentUpdateSuccess())
      yield delay(500) // Small delay to ensure success message is shown before content refresh
      yield put(actionCreation.setHotelProfileContentSuccess(response.data.result_data))
    } else {
      const message = response.data?.result_msg || "Failed to update hotel profile content"
      yield put(actionCreation.setHotelProfileContentUpdateFailure(message))
    }
  } catch (error: any) {
    const message = error?.message || "An unexpected error occurred"
    yield put(actionCreation.setHotelProfileContentUpdateFailure(message))
  }
}

function* hotelProfileGoogleMapUpdateProcess({ payload }: actions.HotelProfileGoogleMapUpdate): SagaIterator {
  try {
    const authState = yield select((state: RootState) => state.auth)
    const hotelProfileState = yield select((state: RootState) => state.hotelProfileConfig)
    const { propCode } = authState

    const url = `${API_PMS_URL}/admin/hotel_profile/update`
    const API_BODY: actions.HotelProfileResponse = {
      prop_code: propCode,
      ...hotelProfileState.dataSource,
      map_url: payload.mapShareUrl,
      map_iframe: payload.mapIframe,
    }

    const response = yield call(APIPostRequest, url, API_BODY, API_HEADERS)

    if (response.status === 200 && response.data?.result_code === "0") {
      yield put(actionCreation.setHotelProfileGoogleMapUpdateSuccess())
      yield delay(500) // Small delay to ensure success message is shown before content refresh
      yield put(actionCreation.setHotelProfileContentSuccess(response.data.result_data))
    } else {
      const message = response.data?.result_msg || "Failed to update Google Map settings"
      yield put(actionCreation.setHotelProfileGoogleMapUpdateFailure(message))
    }
  } catch (error: any) {
    const message = error?.message || "An unexpected error occurred"
    yield put(actionCreation.setHotelProfileGoogleMapUpdateFailure(message))
  }
}

function* hotelProfileGalleryUpdateProcess({ payload }: actions.HotelProfileGalleryUpdate): SagaIterator {
  try {
    const authState = yield select((state: RootState) => state.auth)
    const hotelProfileState = yield select((state: RootState) => state.hotelProfileConfig)
    const { propCode } = authState

    const url = `${API_PMS_URL}/admin/hotel_profile/update`
    const API_BODY: actions.HotelProfileResponse = {
      prop_code: propCode,
      ...hotelProfileState.dataSource,
      images: payload.images,
    }

    const response = yield call(APIPostRequest, url, API_BODY, API_HEADERS)

    if (response.status === 200 && response.data?.result_code === "0") {
      yield put(actionCreation.setHotelProfileGalleryUpdateSuccess())
      yield delay(500) // Small delay to ensure success message is shown before content refresh
      yield put(actionCreation.setHotelProfileContentSuccess(response.data.result_data))
    } else {
      const message = response.data?.result_msg || "Failed to update gallery images"
      yield put(actionCreation.setHotelProfileGalleryUpdateFailure(message))
    }
  } catch (error: any) {
    const message = error?.message || "An unexpected error occurred"
    yield put(actionCreation.setHotelProfileGalleryUpdateFailure(message))
  }
}

function* hotelProfileContentRequest() {
  yield takeLatest(actions.HOTEL_PROFILE_CONTENT_REQUEST, hotelProfileContentRequestProcess)
}

function* hotelProfileContentUpdateBatchRequest() {
  yield takeLatest(actions.HOTEL_PROFILE_CONTENT_UPDATE_BATCH_REQUEST, hotelProfileContentUpdateBatchProcess)
}

function* hotelProfileGoogleMapUpdateRequest() {
  yield takeLatest(actions.HOTEL_PROFILE_GOOGLE_MAP_UPDATE, hotelProfileGoogleMapUpdateProcess)
}

function* hotelProfileGalleryUpdateRequest() {
  yield takeLatest(actions.HOTEL_PROFILE_GALLERY_UPDATE, hotelProfileGalleryUpdateProcess)
}

export default function* rootHotelProfileConfigSaga() {
  yield all([
    fork(hotelProfileContentUpdateBatchRequest),
    fork(hotelProfileContentRequest),
    fork(hotelProfileGoogleMapUpdateRequest),
    fork(hotelProfileGalleryUpdateRequest),
  ])
}
